/* js/testimonial-slider.js */

/* js/employee-slider.js */

;(function($, window, document) {
    
$( document ).ready(function() {
    
    if (typeof $.fn.slick == 'function') {
    
        $('.testimonial-slider').slick({

            arrows: true,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
        
                    }
                }
              ]
              
        });
    
    }
    
});

})(jQuery, window, document);